
import { defineComponent } from "vue";

export default defineComponent({
  name: "PianoKey",
  props: {
    note: {
      type: Object,
      required: true,
    },
    playNote: {
      type: Function,
      required: true,
    },
    stopNote: {
      type: Function,
      required: true,
    },
    isActive: Boolean,
  },
  methods: {
    onMouseDown() {
      this.playNote(this.note.frequency, this.note.label);
    },
    onMouseUp() {
      this.stopNote();
    },
  },
});
